import React from 'react';
import type { LandingHeaderSqueezeEntry } from 'schema';

import { LandingHeaderSqueeze, LANDING_HEADER_SQUEEZE_CONTENT } from './';

export const ContentfulLandingHeaderSqueeze = (
  props: LandingHeaderSqueezeEntry,
) => (
  <LandingHeaderSqueeze
    images={LANDING_HEADER_SQUEEZE_CONTENT.images}
    {...props}
  />
);
